<template>
  <header class="link-header">
    <section class="top-link">
      <ul>
        <li v-for="(item, idx) in topLinks" :key="idx">
          <a rel="nofollow" href="javascript:;" class="link" v-if="!item.link">
            {{ $t(item.name) }}
            <div class="logo-name">
              <img :src="item.logo" :alt="item.value" />
              {{ $t(item.value) }}
            </div>
          </a>
          <a
            v-else
            rel="nofollow"
            target="_blank"
            :href="item.link"
            class="link"
          >{{ $t(item.name) }}</a>
        </li>
      </ul>
    </section>
    <section id="my-header">
      <section class="main">
        <h1 v-if="isH1">
          <nuxt-link :to="$i18n.path('')">
            <img class="logo" src="https://cdn.gelonghui.com/static/web/glh-logo.png" alt="LOGO" />
          </nuxt-link>
        </h1>
        <h2 v-else>
          <nuxt-link :to="$i18n.path('')">
            <img class="logo" src="https://cdn.gelonghui.com/static/web/glh-logo.png" alt="LOGO" />
          </nuxt-link>
        </h2>
        <ul>
          <nuxt-link
            v-for="item in navs"
            :key="item.url"
            :href="$i18n.path(item.url)"
            :to="$i18n.path(item.url)"
            exact
            tag="li"
          >
            {{$t(item.text)}}
            <!-- <li :class="{'active':itemShow === item.text}">{{ $t(item.text) }}</li> -->
          </nuxt-link>
          <a href="https://gogudata.com/" target="_blank" class="gurudata" rel="nofollow">
            <li>
              {{$t('glh-header.navs.data')}}
              <i class="iconfont icon-new">&#xe640;</i>
            </li>
          </a>
        </ul>
        <div class="flex-hold"></div>
        <search class="search-box"></search>
        <div class="button-set">
          <div @click="toggleLang" class="language">
            <span class="simple">{{ locale === 'zh-hk' ? '简' : '繁' }}</span>
            <span>切换</span>
          </div>
          <div v-if="!isLogin" class="no-login">
            <a
              href="javascript:;"
              @click="show(false)"
              class="login"
              rel="nofollow"
            >{{ $t('glh-header.user.signin') }}</a>
            <span class="line">/</span>
            <a
              href="javascript:;"
              @click="show(true)"
              class="register"
              rel="nofollow"
            >{{ $t('glh-header.user.regist') }}</a>
          </div>
          <section v-else class="has-login">
            <div class="divider"></div>
            <!-- 这两个点击事件是为了兼容旧网站 -->
            <div @click="toArticle()" class="edit-box">
              <div class="icon icon-edit"></div>
              <span>投稿</span>
            </div>
            <!-- <div class="divider"></div>
            <div
              class="icon icon-bell"
              @click="toHome()"
            ></div>-->
            <div class="divider"></div>
            <div class="avatar-block">
              <img class="avatar" :src="avatar" @click="gotoCenter" />
              <img v-if="vipInfo.vipType" :src="vipIcon" alt class="vip-icon" />
              <ul class="user-menu">
                <li
                  @click="item.onClick"
                  v-for="(item, idx) in userMenu"
                  :key="idx"
                  class="user-menu-item"
                >{{ $t(item.text) }}</li>
              </ul>
            </div>
          </section>
        </div>
      </section>
    </section>
  </header>
</template>

<script>
import * as types from '@/types';
import search from './search';
import { mapMutations, mapGetters, mapState, mapActions } from 'vuex';

function debounce(func) {
  let timer = null;
  return function() {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      func.call(this);
      timer = null;
    }, 300);
  };
}

export default {
  data() {
    return {
      topLinks: [
        {
          name: 'glh-header.top-links.hk-stock.title',
          value: 'glh-header.top-links.hk-stock.desc',
          logo: 'https://cdn.gelonghui.com/static/web/hkstocks.png'
        },
        {
          name: 'glh-header.top-links.glh.title',
          value: 'glh-header.top-links.glh.desc',
          logo: 'https://cdn.gelonghui.com/static/web/glhapp.png'
        },
        {
          name: 'glh-header.top-links.hly.title',
          value: 'glh-header.top-links.hly.desc',
          logo: 'https://cdn.gelonghui.com/static/web/roadshowapp.png'
        },
        {
          name: 'glh-header.top-links.ipo.title',
          value: 'glh-header.top-links.ipo.desc',
          logo: 'https://cdn.gelonghui.com/static/web/ipopress.png'
        },

        {
          name: 'glh-header.top-links.breakfast.title',
          value: 'glh-header.top-links.breakfast.desc',
          logo: 'https://cdn.gelonghui.com/static/web/hkguruclub.png'
        },
        {
          name: 'glh-header.top-links.join-us.title',
          value: 'glh-header.top-links.join-us.desc',
          logo: '',
          link: 'http://www.gelonghui.com/recruit'
        }
      ],
      navs: [
        {
          text: 'glh-header.navs.home',
          url: ''
        },
        {
          text: 'glh-header.navs.live',
          url: 'live'
        },
        {
          text: 'glh-header.navs.news',
          url: 'news'
        },
        {
          text: 'glh-header.navs.subject',
          url: 'subject'
        },
        // {
        //   text: "glh-header.navs.column",
        //   url: "column"
        // },
        {
          text: 'glh-header.navs.market',
          url: 'market'
        },
        {
          text: 'glh-header.navs.member',
          url: 'member'
        }
      ],
      userMenu: [
        {
          text: 'glh-header.user.my-article',
          onClick: () => {
            this.$router.push('/my/publish');
          }
        },
        {
          text: 'glh-header.user.my-favorite',
          onClick: () => {
            this.$router.push('/my/favorite');
          }
        },
        {
          text: 'glh-header.user.my-purchase',
          onClick: () => {
            this.$router.push('/my/purchase');
          }
        },
        {
          text: 'glh-header.user.setting',
          onClick: () => {
            this.$router.push('/my/setting');
          }
        },
        {
          text: 'glh-header.user.logout',
          onClick: () => this.logout()
        }
      ],
      isH1: true,
      itemShow: '',
      isChangingLang: false
    };
  },
  methods: {
    gotoCenter() {
      window.location.href = '/my/publish';
    },
    toArticle() {
      window.open(
        `/articleCreate/norpub.html?${Math.floor(Math.random() * 10)}`
      );
      // if (this.roleList.indexOf("COLUMN_AUTHOR") > -1) {
      //   window.open(
      //     `/articleCreate/colpub.html?${Math.floor(Math.random() * 10)}`
      //   );
      // } else {
      //   window.open(
      //     `/articleCreate/norpub.html?${Math.floor(Math.random() * 10)}`
      //   );
      // }
    },
    toHome() {
      window.location.href = '/myHome/commentMe';
    },
    toggleLang: debounce(function() {
      if (this.isChangingLang) {
        return;
      }
      this.isChangingLang = true;
      if (this.locale === 'zh-cn') {
        localStorage.setItem('lang', 'zh-hk');
        this.$router.push(`/zh-hk${this.$route.fullPath}`);
      } else {
        localStorage.setItem('lang', 'zh-cn');
        this.$router.push(this.$route.fullPath.replace('/zh-hk', ''));
      }
    }),
    selectSort(item) {
      this.itemShow = item;
    },
    ...mapMutations('user', {
      show: types.SHOW_LOGIN_FORM
    }),
    ...mapActions('user', {
      logout: types.LOGOUT
    })
  },
  created() {
    if (
      this.$route.name === 'news-id' ||
      this.$route.name === 'p-id' ||
      this.$route.name === 'live-id'
    ) {
      this.isH1 = false;
    }
    //路由判断
    if (this.$route.path === '/' || this.$route.path === '/zh-hk/') {
      this.itemShow = 'glh-header.navs.home';
    } else if (this.$route.path.indexOf('/column') > -1) {
      this.itemShow = 'glh-header.navs.column';
    } else if (this.$route.path.indexOf('/news') > -1) {
      this.itemShow = 'glh-header.navs.news';
    } else if (this.$route.path.indexOf('/live') > -1) {
      this.itemShow = 'glh-header.navs.live';
    } else if (this.$route.path.indexOf('/subject') > -1) {
      this.itemShow = 'glh-header.navs.subject';
    } else if (this.$route.path.indexOf('/stock') > -1) {
      this.itemShow = 'glh-header.navs.stock';
    } else if (this.$route.path.indexOf('/market') > -1) {
      this.itemShow = 'glh-header.navs.market';
    } else {
      this.itemShow = 'glh-header.navs.data';
    }
  },
  computed: {
    ...mapGetters('user', ['isLogin', 'avatar', 'roleList', 'vipInfo']),
    ...mapState(['locale']),
    vipIcon() {
      if (!this.vipInfo.vipType) {
        return '';
      }
      const icons = {
        gold:
          'https://cdn.gelonghui.com/static/web/header_icon_vip_purchase_gold.png',
        platinum:
          'https://cdn.gelonghui.com/static/web/header_icon_vip_purchase_platinum.png',
        ultimate:
          'https://cdn.gelonghui.com/static/web/header_icon_vip_purchase_niello.png'
      };
      return icons[this.vipInfo.vipType];
    }
  },
  watch: {
    $route() {
      if (
        this.$route.name === 'news-id' ||
        this.$route.name === 'p-id' ||
        this.$route.name === 'live-id'
      ) {
        this.isH1 = false;
      }
    }
  },
  mounted() {
    // 新旧网站简繁体衔接
    const lang = localStorage.getItem('lang');
    if (lang === 'zh-hk' && this.locale === 'zh-cn') {
      this.toggleLang();
    } else if (
      (lang === null || lang === undefined || lang === 'zh-cn') &&
      this.locale === 'zh-hk'
    ) {
      this.toggleLang();
    }
  },
  components: {
    search
  },
  watch: {
    locale() {
      this.isChangingLang = false;
    }
  }
};
</script>

<style lang="less" scoped>
.flex-hold {
  flex-grow: 1;
}

.link-header {
  .top-link {
    width: 100%;
    height: 30px;
    line-height: 30px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    background: #2a2a2a;

    ul {
      display: flex;
      width: 1200px;
      margin: auto;
      justify-content: flex-end;

      li {
        text-align: right;
        margin-left: 30px;
        height: 100%;

        a {
          font-size: 12px;
          color: #fff;
          position: relative;
          cursor: pointer;
          border-bottom: 1px solid rgb(135, 135, 135);

          .logo-name {
            position: absolute;
            padding: 20px;
            text-align: center;
            background: #fff;
            top: 22px;
            left: -50px;
            right: 0;
            margin: auto;
            display: none;
            z-index: 999;
            width: 160px;
            height: 172px;
            color: #222;
            font-size: 14px;
            box-shadow: 0px 0px 10px rgba(31, 62, 178, 0.18);

            img {
              width: 120px;
              display: block;
            }
          }
        }

        &:hover .logo-name {
          display: block;
        }
      }
    }
  }

  #my-header {
    width: 100%;
    height: 70px;
    position: fixed;
    top: 30px;
    left: 0;
    z-index: 99;
    background: #fff;
    border-bottom: 1px solid #f1f3f7;

    .main {
      max-width: 1200px;
      margin: auto;
      height: 70px;
      position: relative;
      display: flex;

      h1,
      h2 {
        height: 70px;
        width: 100px;

        // display: inline-block;
        // position: absolute;
        // top:0;
        // bottom:0;
        // margin:auto;
        img {
          height: 28px;
          width: 100px;
          position: absolute;
          top: 0;
          bottom: 0;
          margin: auto;
        }
      }

      > ul {
        height: 70px;
        margin-left: 20px;
        display: -ms-flexbox;

        display: flex;
        width: 450px;
        -ms-flex-pack: justify;
        justify-content: space-between;
        align-items: center;
        position: relative;

        > li {
          color: #222;
          // width: 66px;
          height: 100%;
          text-align: center;
          line-height: 1;
          margin: 0 10px;

          &.nuxt-link-active {
            color: #333;
            font-weight: 900;
            font-size: 16px;
          }
        }
        a.gurudata {
          color: #222;
          // width: 66px;
          height: 100%;
          text-align: center;
          line-height: 1;
          margin: 0 10px;
          position: relative;
          &:hover {
            .icon-new {
              position: absolute;
              color: #ffab00;
              font-size: 25px;
              top: -5px;
              font-weight: 400;
            }
          }
          .icon-new {
            position: absolute;
            color: #ffab00;
            font-size: 25px;
            top: -5px;
            font-weight: 400;
          }
        }
        li {
          float: left;
          cursor: pointer;
          font-size: 16px;
          width: 100%;
          height: 100%;
          line-height: 70px;
          width: 40px;

          &:hover {
            font-weight: 700;
            color: #333;
          }

          a {
            color: #222;
          }
        }

        .active {
          // color: #333;
          // border-bottom: 4px solid rgb(50, 120, 210);
          // font-weight: 700;
          // font-size: 18px;
          font-weight: 900;
        }
      }

      .search-box {
        margin-right: 15px;
      }

      .button-set {
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-end;
        align-items: center;
        font-size: 14px;
        font-weight: 600;
        color: #000;

        .language {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 10px;
          cursor: pointer;

          span {
            color: #666666;
          }

          .simple {
            margin-right: 5px;
            border-right: 1px solid #ccc;
            z-index: 99;
            display: block;
            color: #838d97;
            padding: 5px;
            border: 1px solid #838d97;
            border-radius: 14px;
            line-height: 14px;
            font-size: 14px;
          }
        }

        .no-login {
          display: -ms-flexbox;
          display: flex;
          flex-flow: row nowrap;
          justify-content: space-between;
          align-items: center;

          .login {
            padding-left: 20px !important;
            border-left: 1px solid #ccc;
            cursor: pointer;
            font-size: 14px;
            font-weight: 600;
            color: #000;
          }

          .register {
            cursor: pointer;
            font-size: 14px;
            font-weight: 600;
            color: #000;
          }

          .line {
            margin: 0 10px;
          }
        }

        .has-login {
          display: flex;
          position: relative;

          align-items: center;

          .icon {
            height: 22px;
            width: 22px;
            margin: 0 22px;
          }

          .divider {
            width: 1px;
            height: 14px;

            background: #e8e8e8;
          }

          .edit-box {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-right: 10px;
            color: #666666;
            cursor: pointer;

            .icon {
              margin-right: 5px;
            }
          }

          .icon-bell {
            background: no-repeat center/contain
              url('~assets/img/icon-bell.png');
            cursor: pointer;
          }

          .icon-edit {
            background: no-repeat center/contain
              url('~assets/img/icon-edit.png');
          }

          .avatar-block {
            position: relative;
            cursor: pointer;
            .avatar {
              height: 40px;
              width: 40px;
              margin: 0 25px;

              border-radius: 50%;
            }

            .vip-icon {
              position: absolute;
              bottom: 0px;
              right: 23px;
              width: 15px;
              height: 12px;
            }
            &:hover > .user-menu {
              display: block;
            }

            .user-menu {
              position: absolute;
              left: 50%;
              top: 100%;
              display: none;

              transform: translateX(-50%);

              &:hover {
                display: block;
              }

              .user-menu-item {
                width: 120px;
                height: 40px;

                line-height: 40px;
                text-align: center;
                font-weight: 400;

                background: #fff;

                &:hover {
                  background: #eee;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
